export const SYSTEM_LOGS_CACHE_DURATION_MINUTES = 10;
